/**
 * Calculate the current UK tax year based on the current date
 * UK tax year runs from April 6th to April 5th of the following year
 * @returns {string} Tax year in format "YYYY/YY" (e.g., "2025/26")
 */
export const getCurrentUKTaxYear = () => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth(); // 0-based (0 = January, 3 = April)
    const currentDay = now.getDate();
    
    // UK tax year starts on April 6th (month 3, day 6)
    let taxYearStart, taxYearEnd;
    
    if (currentMonth < 3 || (currentMonth === 3 && currentDay < 6)) {
        // Before April 6th - still in previous tax year
        taxYearStart = currentYear - 1;
        taxYearEnd = currentYear;
    } else {
        // April 6th or later - in current tax year
        taxYearStart = currentYear;
        taxYearEnd = currentYear + 1;
    }
    
    // Format as "YYYY/YY"
    const endYearShort = taxYearEnd.toString().slice(-2);
    return `${taxYearStart}/${endYearShort}`;
};

/**
 * Format currency amount for display
 * @param {number} amount - Amount in pounds
 * @returns {string} Formatted currency string
 */
export const formatISAAmount = (amount) => {
    return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(amount);
};
